import { createReducer } from '@reduxjs/toolkit'

import { CategoryTag, Content } from '@lyrahealth-inc/shared-app-logic/src/models/assignments/Assignments'
import { Program } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'

import { GET_CONTENT_CATEGORIES_TAGS, GET_CONTENTS, GET_PROGRAMS } from '../../common/constants/reduxConstants'

type ContentsState = {
  data: Content[]
  assessmentsData: Content[]
  categoryTagsData: CategoryTag[]
  programs: Program[]
}

const initialState = {
  data: [],
  assessmentsData: [],
  programs: [],
  categoryTagsData: [],
}

export default createReducer<ContentsState>(initialState, (builder) => {
  builder.addCase(GET_CONTENTS, (state, action: any) => {
    const contents = action.data.filter((content: Content) => content.group !== 'assessment')
    state.data = contents
    state.assessmentsData = action.data.filter((content: Content) => content.group === 'assessment')
    return state
  })
  builder.addCase(GET_CONTENT_CATEGORIES_TAGS, (state, action: any) => {
    const contentCategoriesTags = action.data
    state.categoryTagsData = contentCategoriesTags
    return state
  })
  builder.addCase(GET_PROGRAMS, (state, action: any) => {
    state.programs = action.data
    return state
  })
})
